import React, { useState } from 'react'
import PropTypes from 'prop-types'
import context from '@/context'
import Resx from '@/components/Resx'
import { Button } from 'reactstrap'
import Icon from '@/components/Icon'
import history from '@/utils/history'
import { newChangeItemIcon } from './icons'
import { getChangeItemUrl } from '@/components/changeRequests/urls'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { activeTaskSelector } from '@/components/changeRequests/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { actionCreators as myActiveTaskActions } from '@/store/myActiveTask'

const CreateChangeItem = ({ buttonText, scope, targetId, additionalPermission, isClassCompany = true }) => {
  const [creating, setCreating] = useState(false)
  const isGranted = usePermissionChecker()
  const dispatch = useDispatch()

  const activeTask = useSelector(activeTaskSelector)
  const hasScopePermission = isGranted(`Scopes.${scope}.${targetId ? 'Edit' : 'Create'}`)
  const isAdditionalGranted = additionalPermission ? isGranted(additionalPermission) : true

  const isManageMergeTask = activeTask && activeTask.type && activeTask.type.code === 'ManageMergedCompanies'
  const isMergeCreationLimitReached = isManageMergeTask && activeTask.changeRequest.items.length >= 1
  const classCompanyCondition = (isClassCompany && isManageMergeTask && !isMergeCreationLimitReached) || !isManageMergeTask

  const displayButton = hasScopePermission && isAdditionalGranted && classCompanyCondition

  const onClick = () => {
    setCreating(true)
    context.api.changeRequestService.createChangeItem({ scope, targetId })
      .then(response => {
        const { id, success } = response

        if (!success) {
          setCreating(false)
        } else if (typeof id === 'number') {
          history.push(getChangeItemUrl(scope, id))
          dispatch(myActiveTaskActions.getMyActiveTask())
        } else {
          setCreating(false)
        }
      }).catch(() => {
        setCreating(false)
      })
  }

  return (
    displayButton && (
      <Button color='primary' className='btn-sm' disabled={creating} onClick={onClick}>
        <Icon name={creating ? 'bx-loader bx-spin' : newChangeItemIcon} /> <span><Resx name={buttonText} /></span>
      </Button>
    )
  )
}

CreateChangeItem.propTypes = {
  buttonText: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  targetId: PropTypes.number,
  additionalPermission: PropTypes.string
}

export { CreateChangeItem }



// WEBPACK FOOTER //
// ./src/components/changeRequests/createChangeItem.js